import SlideFrame from "./_SlideFrame";
import { Clock, Percent, AlertTriangle, Scale } from "lucide-react";

const ITEMS = [
  {
    icon: Clock,
    k: "Onboarding",
    v: "Months, not weeks",
    d: "Legacy servicers board new portfolios on quarterly cycles — killing your time to market.",
  },
  {
    icon: Percent,
    k: "Pricing",
    v: "UPB pricing is a tax on your book",
    d: "Percentage-of-UPB models charge you more as your portfolio performs. You scale, they collect the upside. That's a tax on growth — not a service fee.",
  },
  {
    icon: AlertTriangle,
    k: "Expertise",
    v: "Platforms ship APIs, not operators",
    d: "Tech-only providers hand you dashboards and leave you to staff borrower escalations, compliance, and recovery yourself.",
  },
  {
    icon: Scale,
    k: "Compliance",
    v: "Examiner expectations keep rising",
    d: "Staffing a best-in-class compliance program in-house is unaffordable for most lenders — and table stakes for the regulators.",
  },
];

export default function SlideBottleneck() {
  return (
    <SlideFrame tag="01 · The Case">
      <p className="overline mb-6">The hidden bottleneck</p>
      <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-5xl">
        Four frictions that compound after every loan you fund — and one of them is a <em className="italic text-primary">tax</em>.
      </h2>

      <div className="mt-12 grid md:grid-cols-2 gap-px bg-foreground/20 border border-foreground/20">
        {ITEMS.map(({ icon: Icon, k, v, d }, i) => {
          const isTax = k === "Pricing";
          return (
            <div key={i} className={`bg-background p-8 md:p-10 ${isTax ? "border-l-4 border-l-primary" : ""}`}>
              <div className="flex items-center gap-3 mb-6">
                <Icon className={`w-4 h-4 ${isTax ? "text-primary" : ""}`} strokeWidth={1.5} />
                <span className={`overline ${isTax ? "text-primary" : ""}`}>{k}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl tracking-tight leading-snug">{v}</h3>
              <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-sm">{d}</p>
            </div>
          );
        })}
      </div>

      <p className="mt-10 font-display text-xl md:text-2xl italic text-foreground/80 max-w-3xl">
        A flat, per-account fee replaces the UPB tax — your cost stops climbing the moment your
        portfolio starts performing.
      </p>
    </SlideFrame>
  );
}
